module.exports = __webpack_public_path__ + "static/media/green_check.ff88ff7b.svg";